import { render, staticRenderFns } from "./NoteCreate.vue?vue&type=template&id=51becf77&scoped=true&"
import script from "./NoteCreate.vue?vue&type=script&lang=js&"
export * from "./NoteCreate.vue?vue&type=script&lang=js&"
import style0 from "./NoteCreate.vue?vue&type=style&index=0&id=51becf77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51becf77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VTextarea})
